import { deleteBanner } from 'Services/Features/Branch/Utils/branchUtils';
import Swal from 'sweetalert2';

export const handleDeleteBanner = async (dispatch, id, pivotId, setRefetch, setClickedIndex ) => {
    setClickedIndex(pivotId);
    try {
        Swal.fire({
            title: 'Apakah anda yakin?',
            text: "Anda tidak dapat mengembalikan data yang telah dihapus!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33'
        }).then(async (result) => {
            if (result.isConfirmed) {
                await dispatch(deleteBanner({ id, pivotId }));
                setRefetch(prevRefetch => !prevRefetch);
                Swal.fire(
                    'Terhapus!',
                    'Banner telah dihapus.',
                    'success'
                )
            } else {
                setClickedIndex(null);
            } 
        })
    } catch (error) {
        Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: error.message
        });
        console.error(error);
    }
}